/**
 * ソート関係の設定定義
 */
import { SortTypeCode } from '@/models/sortModel'

export class SortSettings {
  // 昇順
  static readonly ASC: SortSetting = {
    code: 'asc',
    directionChar: 'up',
    nextSort: 'DESC',
  }
  // 降順
  static readonly DESC: SortSetting = {
    code: 'desc',
    directionChar: 'down',
    nextSort: 'NONE',
  }
  // ソートなし
  static readonly NONE: SortSetting = {
    code: null,
    directionChar: 'none',
    nextSort: 'ASC',
  }

  // 設定一覧
  static readonly LIST = [SortSettings.ASC, SortSettings.DESC, SortSettings.NONE]

  // コードで設定を取得
  static findByCode(code: SortTypeCode): SortSetting {
    return (
      SortSettings.LIST.find((setting) => {
        return setting.code === code
      }) || SortSettings.NONE
    )
  }
}

export type SortSetting = {
  // ソート区分コード
  code: SortTypeCode
  // ボタンの方向名称
  directionChar: string
  // ボタン押下時のソート切り替え先
  nextSort: string
}
